var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoxSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fox 1",
    clipPath: "url(#clip0_4998_107990)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4656 0.146733C15.8564 -0.0025406 16.2763 0.292315 16.2581 0.710217C16.1116 4.07822 14.9523 6.98163 14.9523 6.98163L10.5732 3.90905C12.3191 1.80621 14.4317 0.541713 15.4656 0.146733Z",
    fill: "#D26437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0322 4.93322C13.1702 3.08 14.8866 1.31051 15.43 0.994808C15.6503 0.866839 15.8437 1.17994 15.7944 1.59264C15.5319 3.7892 15.0559 5.76214 14.7628 6.84917L12.0322 4.93322Z",
    fill: "#B44632"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.53333 0.146733C2.14257 -0.0025406 1.72263 0.292315 1.7408 0.710217C1.88734 4.07822 3.04668 6.98163 3.04668 6.98163L7.42571 3.90905C5.67982 1.80621 3.56721 0.541713 2.53333 0.146733Z",
    fill: "#D26437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.96717 4.93322C4.82923 3.08 3.11283 1.31051 2.56942 0.994808C2.34913 0.866839 2.1557 1.17994 2.20503 1.59264C2.46747 3.7892 2.94348 5.76214 3.23662 6.84917L5.96717 4.93322Z",
    fill: "#B44632"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.00169 17.8927C9.96372 17.8927 10.7436 17.3728 10.7436 16.7315C10.7436 16.0902 9.96372 15.5703 9.00169 15.5703C8.03965 15.5703 7.25977 16.0902 7.25977 16.7315C7.25977 17.3728 8.03965 17.8927 9.00169 17.8927Z",
    fill: "#EBC9A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.96772 16.4411C4.93548 15.2798 1.56867 14.0155 1.56867 14.0155L1.89176 13.0462C1.75556 12.9815 0.822551 12.9693 0 13.2475L0.870961 11.7959H6.96772V16.4411Z",
    fill: "#EBC9A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.0332 16.4411C13.0654 15.2798 16.4323 14.0155 16.4323 14.0155L16.1092 13.0462C16.2454 12.9815 17.1784 12.9693 18.0009 13.2475L17.13 11.7959H11.0332V16.4411Z",
    fill: "#EBC9A0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9 3.37695C13.232 3.37695 16.865 7.61715 17.9869 13.1824C17.9913 13.2042 17.9957 13.226 18 13.2479C18 13.2479 15.8589 11.0342 13.5363 12.2137C12.675 12.651 12.2661 13.612 12.2661 14.6621C12.2661 16.4032 10.8705 17.3665 9.21702 16.6973C9.07685 16.6406 8.92311 16.6406 8.78295 16.6973C7.12951 17.3665 5.73384 16.4032 5.73384 14.6621C5.73384 13.612 5.32494 12.651 4.46368 12.2137C2.14112 11.0342 0 13.2479 0 13.2479C0.00432422 13.226 0.00868359 13.2042 0.0130781 13.1824C1.13498 7.61711 4.768 3.37695 9 3.37695Z",
    fill: "#EB874B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.94971 11.5055C5.39084 11.5055 4.93359 11.0482 4.93359 10.4893V9.9087C4.93359 9.34982 5.39084 8.89258 5.94971 8.89258C6.50859 8.89258 6.96584 9.34982 6.96584 9.9087V10.4893C6.96587 11.0482 6.50859 11.5055 5.94971 11.5055Z",
    fill: "#4B3F4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M5.9518 8.89258C5.90212 8.89258 5.85445 8.90035 5.80664 8.90731V10.3442C5.80664 10.6648 6.06662 10.9248 6.38728 10.9248C6.70798 10.9248 6.96792 10.6648 6.96792 10.3442V9.9087C6.96796 9.34982 6.51068 8.89258 5.9518 8.89258Z",
    fill: "#5D5360"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M5.95208 10.0546C6.19259 10.0546 6.38756 9.85958 6.38756 9.61907C6.38756 9.37856 6.19259 9.18359 5.95208 9.18359C5.71157 9.18359 5.5166 9.37856 5.5166 9.61907C5.5166 9.85958 5.71157 10.0546 5.95208 10.0546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M12.0493 11.5055C11.4904 11.5055 11.0332 11.0482 11.0332 10.4893V9.9087C11.0332 9.34982 11.4904 8.89258 12.0493 8.89258C12.6082 8.89258 13.0654 9.34982 13.0654 9.9087V10.4893C13.0654 11.0482 12.6082 11.5055 12.0493 11.5055Z",
    fill: "#4B3F4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.0485 8.89258C11.9988 8.89258 11.9511 8.90035 11.9033 8.90731V10.3442C11.9033 10.6648 12.1633 10.9248 12.484 10.9248C12.8047 10.9248 13.0646 10.6648 13.0646 10.3442V9.9087C13.0646 9.34982 12.6073 8.89258 12.0485 8.89258Z",
    fill: "#5D5360"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M12.0488 10.0546C12.2893 10.0546 12.4842 9.85958 12.4842 9.61907C12.4842 9.37856 12.2893 9.18359 12.0488 9.18359C11.8083 9.18359 11.6133 9.37856 11.6133 9.61907C11.6133 9.85958 11.8083 10.0546 12.0488 10.0546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M8.70996 16.7239C8.7351 16.7144 8.76027 16.7047 8.78551 16.6947C8.92336 16.6398 9.07724 16.6398 9.21509 16.6947C9.24033 16.7047 9.2655 16.7144 9.29064 16.7239V15.5703H8.71L8.70996 16.7239Z",
    fill: "#D26437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M8.98274 13.8281C9.63337 13.8281 10.1608 14.2592 10.1608 14.791C10.1608 15.3039 9.66572 15.5739 9.30839 15.7736C9.10125 15.8893 8.86426 15.8893 8.65712 15.7736C8.29979 15.5739 7.80469 15.3039 7.80469 14.791C7.80465 14.2592 8.3321 13.8281 8.98274 13.8281Z",
    fill: "#5D5360"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M9.27134 15.7489C8.91401 15.4922 8.4189 15.145 8.4189 14.4856C8.4189 14.2695 8.47628 14.0694 8.56888 13.8926C8.12324 14.0299 7.80469 14.3789 7.80469 14.7911C7.80469 15.304 8.29979 15.574 8.65712 15.7737C8.86426 15.8895 9.10129 15.8895 9.30839 15.7737C9.30997 15.7728 9.31177 15.7718 9.31338 15.7709C9.29953 15.7624 9.28494 15.7587 9.27134 15.7489Z",
    fill: "#4B3F4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M9 3.37695L8.43543 3.40518C4.448 3.76255 1.08471 7.86648 0.0130781 13.1823C0.00868359 13.2042 0.00432422 13.226 0 13.2479C0 13.2479 1.72797 11.4631 3.76298 11.9547C4.01745 4.72411 8.52743 3.37695 9 3.37695Z",
    fill: "#D26437"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4998_107990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoxSmall);
export default __webpack_public_path__ + "static/media/fox_small.f3bc55f8084f8b2f2cd25126d59d1236.svg";
export { ForwardRef as ReactComponent };